"use client";

import './index.scss';
import { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import React from "react";
import { getSlugAndRouteName } from '../../../utils/Functions';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
export function AnimatedCard({
  logos,
  isSubIndustryPage
}: {
  logos?: any;
  isSubIndustryPage?: boolean;
}) {
  const careerOptions = ["Growth Hacker", "Product Manager", "UI/UX Designer", "Digital Marketer", "Performance Marketer", "Product Marketer", "D2C Founder", "Startup Founder", "Marketing Manager", "Data Analyst", "Management Consultant", "Data Engineer", "Data Scientist", "Business Analyst", "Public Speaker", "Prompt Engineer", "Creative Professional", "Copywriter"];
  const pathName = usePathname();
  // const {isSubIndustryPage} = getSlugAndRouteName(pathName.toString())

  const repeatedCareerOptions = [...careerOptions, ...careerOptions, ...careerOptions];
  const logoSrcs = logos && logos;
  const repeatedLogos = logoSrcs;
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      if (isSubIndustryPage && repeatedLogos) {
        setActiveIndex(prevIndex => {
          const newIndex = prevIndex + 1;
          return newIndex + 1 >= repeatedLogos.length ? -1 : newIndex;
        });
      } else {
        setActiveIndex(prevIndex => {
          const newIndex = prevIndex + 1;
          return newIndex + 1 >= repeatedCareerOptions.length ? -1 : newIndex;
        });
      }
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  return <div className="section__marquee section__marquee--2" data-sentry-component="AnimatedCard" data-sentry-source-file="index.tsx">
      {<div className="section__marquee-numbers-card-tabs">
                <motion.div animate={{
        y: -activeIndex * 51
      }} transition={{
        type: "tween",
        duration: 0.5
      }} ref={sliderRef} className="section__marquee-numbers-card-tabs-slider">
                  {!isSubIndustryPage ? repeatedCareerOptions.map((option, index) => <div key={index} className={`section__marquee-numbers-card-tab section__marquee-numbers-card-tab--${index + 1} ${index === activeIndex + 1 ? "active" : ""}`}>
                      {option}
                    </div>) : repeatedLogos && repeatedLogos.map((option: any, index: number) => <div key={index} className={`section__marquee-numbers-card-tab section__marquee-numbers-card-tab--${index + 1} ${index === activeIndex + 1 ? "active" : ""}`}>
                      <Image className='logos' src={option} width={140} height={20} alt=''></Image>
                    </div>)}
                </motion.div>
              </div>}
    </div>;
}